export default __webpack_public_path__ + "alberta-info.cdb709afbf2cc6afaf2c.svg";